import React from 'react';
import Slider from "@ant-design/react-slick";
import { Link } from 'react-router-dom'; // Import Link from react-router-dom
import './bannermain.css'; // Import your CSS file
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


export default function BannerMainFull() {
  var settings = {
    dots: true,
    fade: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 500,
    pauseOnHover: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    waitForAnimate: false
  };
  return (

      <Slider {...settings} className='slide-full'>
    <div className='mainfull slibg-1'>
    <div className='slider-box '>
        {/* slide */}
           <div>
           <div className="container xl">
              <div className="row aic banner-content">
                <div className='col-8 col-lg-8 col-md-6 col-sm-12'>
                  <div className='b-text'>
                    <p className='fs-20 text-dark-grey fade-in'>Welcome To</p>
                    <h1 className='d-flex aic text-secondary-color lh-1 alt-font fw-normal mb-15px fade-in'><span className='larg-jp'>JP </span>
                     <span> <span className='d-block fs-64'>International</span> <span className='d-block kanker text-white fs-58'>School Kanker</span>
                    </span> </h1>
                    <p className='mb-15px fade-in trdelay-05'>is now proudly affiliated with</p>
                    <h2 className='fs-64 text-secondary-color alt-font fw-normal lh-1 mb-20px fade-in'>Sainik School</h2>
                    <p className='mb-25px fade-in trdelay-1'>and becomes the <span className='fw-600 text-secondary-color'>first Sainik School</span> in the <span className='fw-600 text-secondary-color '>Bastar Division</span></p>
                    <div><Link className="yellow-button me-10px fade-in trdelay-15">About Us</Link>  <Link className="light-button fade-in trdelay-15">Academics</Link></div>
                  </div>
                </div>
   
              </div>
            </div>
           </div>

           {/* slide-end */}
           </div>
    </div>
    <div className='mainfull slibg-2'>
    <div className='slider-box '>
        {/* slide */}
           <div>
           <div className="container xl">
              <div className="row aic banner-content">
                <div className='col-8 col-lg-8 col-md-6 col-sm-12'>
                  <div className='b-text'>
                    <p className='fs-20 text-dark-grey fade-in'>Welcome To</p>
                    <h1 className='d-flex aic text-secondary-color lh-1 alt-font fw-normal mb-15px fade-in'><span className='larg-jp'>JP </span>
                     <span> <span className='d-block fs-64'>International</span> <span className='d-block kanker text-white fs-58'>School Kanker</span>
                    </span> </h1>
                    <p className='mb-15px fade-in trdelay-05'>is now proudly affiliated with</p>
                    <h2 className='fs-64 text-secondary-color alt-font fw-normal lh-1 mb-20px fade-in'>Sainik School</h2>
                    <p className='mb-25px fade-in trdelay-1'>and becomes the <span className='fw-600 text-secondary-color'>first Sainik School</span> in the <span className='fw-600 text-secondary-color '>Bastar Division</span></p>
                    <div><Link className="yellow-button me-10px fade-in trdelay-15">About Us</Link>  <Link className="light-button fade-in trdelay-15">Academics</Link></div>
                  </div>
                </div>
   
              </div>
            </div>
           </div>

           {/* slide-end */}
           </div>
    </div>
    <div className='mainfull slibg-3'>
    <div className='slider-box '>
        {/* slide */}
           <div>
           <div className="container xl">
              <div className="row aic banner-content">
                <div className='col-8 col-lg-8 col-md-6 col-sm-12'>
                  <div className='b-text'>
                    <p className='fs-20 text-dark-grey fade-in'>Welcome To</p>
                    <h1 className='d-flex aic text-secondary-color lh-1 alt-font fw-normal mb-15px fade-in'><span className='larg-jp'>JP </span>
                     <span> <span className='d-block fs-64'>International</span> <span className='d-block kanker text-white fs-58'>School Kanker</span>
                    </span> </h1>
                    <p className='mb-15px fade-in trdelay-05'>is now proudly affiliated with</p>
                    <h2 className='fs-64 text-secondary-color alt-font fw-normal lh-1 mb-20px fade-in'>Sainik School</h2>
                    <p className='mb-25px fade-in trdelay-1'>and becomes the <span className='fw-600 text-secondary-color'>first Sainik School</span> in the <span className='fw-600 text-secondary-color '>Bastar Division</span></p>
                    <div><Link className="yellow-button me-10px fade-in trdelay-15">About Us</Link>  <Link className="light-button fade-in trdelay-15">Academics</Link></div>
                  </div>
                </div>
   
              </div>
            </div>
           </div>

           {/* slide-end */}
           </div>
    </div>
      </Slider>

  );
}